/* import __COLOCATED_TEMPLATE__ from './upgrade-banner.hbs.js'; */
import Component from '@glimmer/component';
// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class UpgradeBanner extends Component {}